import { render, staticRenderFns } from "./terminate-record-table.vue?vue&type=template&id=150015bd&scoped=true"
import script from "./terminate-record-table.vue?vue&type=script&lang=js"
export * from "./terminate-record-table.vue?vue&type=script&lang=js"
import style0 from "./terminate-record-table.vue?vue&type=style&index=0&id=150015bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150015bd",
  null
  
)

export default component.exports